module.exports = __webpack_public_path__ + "static/hero-sala-tecnica-640-fb5ad3100d42b696f32a1803c0fca207.jpg";